import { render, staticRenderFns } from "./BaseCallout.vue?vue&type=template&id=d453c918&scoped=true&"
import script from "./BaseCallout.vue?vue&type=script&lang=js&"
export * from "./BaseCallout.vue?vue&type=script&lang=js&"
import style0 from "./BaseCallout.vue?vue&type=style&index=0&id=d453c918&scoped=true&lang=scss&"
import style1 from "./BaseCallout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d453c918",
  null
  
)

export default component.exports